// extracted by mini-css-extract-plugin
export default {"container":"EmployeeList_container__j8Gze"};